import { Skeleton } from '@acctglobal/skeleton'
import { Carousel, ProductCardSeeMore } from '@plurix/ecom-components'
import React from 'react'
import { handleProductCardSeeMore } from 'src/local_modules/utils/handleProductSeeAllCard'

import { useAnotherScPrices } from '../../../../../hooks/useAnotherScPrices'
import { useProductWithLowStock } from '../../../../../hooks/useProductWithLowStock'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'
import { carouselProps } from '../../../../../utils/carouselProps'
import ProductCard from '../../../../product/ProductCard'

import type {
  ProductLayout,
  ProductsQueryResponse,
} from '../../../../../types/Product'

import '@plurix/ecom-components/dist/styles/product-card-see-more-horizontal.global.css'

interface ShelfContentProps {
  products: ProductsQueryResponse['node'][]
  seeMoreLink: string
  disableSeeMoreCard?: boolean
  location: string
  layout?: ProductLayout
}

export const ShelfContent = ({
  products,
  seeMoreLink,
  disableSeeMoreCard,
  location,
  layout,
}: ShelfContentProps) => {
  const { getAnotherScPrices } = useAnotherScPrices(products)
  const { productsWithLowStock, loading } = useProductWithLowStock(products)
  const { width } = useWindowDimensions()

  if (!width || loading) {
    return <Skeleton height={500} />
  }

  const { arrow, bullet } = carouselProps(width)

  return (
    <Carousel arrow={arrow} bullet={bullet}>
      {productsWithLowStock?.map((product) => {
        const anotherScPrices = getAnotherScPrices(product.sku)

        return (
          <ProductCard
            key={product.id}
            product={product}
            location={location}
            titleLevel={3}
            layout={layout}
            {...anotherScPrices}
          />
        )
      })}

      {!disableSeeMoreCard && (
        <ProductCardSeeMore
          text={'Produtos da mesma Categoria'}
          link={seeMoreLink || ''}
          variant={layout}
          taggingEvent={handleProductCardSeeMore}
        />
      )}
    </Carousel>
  )
}
